module.exports = __webpack_public_path__ + "static/media/icone-app.92deecc1.png";